<template>
  <div class="skeleton-container">
    <div class="skeleton-container__box">
      <div
        class="gradient element"
        :key="index"
        v-for="(loading, index) in lineCount"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ListViewSkeleton",
  props: {
    lineCount: {
      type: Number,
      default: 10,
    },
  },
};
</script>

<style lang="scss" scoped>
.skeleton-container {
  width: 100%;
  height: auto;
  margin: 0 auto;
  overflow: hidden;

  &__box {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .element {
      height: 16px;
      width: 100%;
    }
  }
}

.gradient {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #fafafa;
  background: linear-gradient(
    to right,
    #fafafa 15%,
    #cdcdcd 20%,
    #fafafa 30%,
    #fafafa 15%
  );
  background-size: 1000px 640px;
  border-radius: 15px;
  position: relative;
}

@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
</style>
